import { Stack } from '@fluentui/react';
import * as React from 'react';
import { LabelListItem } from '.';
import { Opinion, hasLabel } from 'services';

export interface LabelListProps {
  opinion: Opinion;
  disabled: boolean;
  labelsData: string[];
  onClick(Label): void;
}

export const LabelList: React.FunctionComponent<LabelListProps> = props => {
  return (
    <Stack tokens={{ childrenGap: 5 }}>
      {props.labelsData.map(label => {
        return (
          <Stack.Item key={label}>
            <LabelListItem
              key={label}
              label={label}
              disabled={props.disabled && !hasLabel(props.opinion, label)}
              onClick={(): void => props.onClick(label)}
            />
          </Stack.Item>
        );
      })}
    </Stack>
  );
};
